/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    arrayOf,
    bool,
    func,
    number,
    object,
    shape,
    string,
    array,
} from 'prop-types';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
    Button, Dialog, DialogTitle, useMediaQuery,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogContent from '@material-ui/core/DialogContent';
import FilterIcon from '../../../../BrandTheme/Icons/FilterSvgIcon';
import ProductFacetsV3 from './ProductFacetsV3';
import FilterChipsUI from './FilterChipsUI';
import { getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import DesktopFilterDialogV3 from '../FilterDialog/DesktopFilterDialog/DesktopFilterDialogV3';
import CollectionProductCountUI from '../../CollectionProductCountUI';

const styles = (theme) => ({
    mainFilterContainerMobileV3: {
        display: 'flex',
        margin: '0 -20px 0 -20px',
        borderTop: '1px solid black',
        borderBottom: '1px solid black',
        '&.plantGuide': {
            margin: 'unset !important',
        },
    },
    filterButtonFood: {
        display: 'flex',
        alignItems: 'center',
        '&>span': {
            fontSize: '1rem',
            display: 'flex',
            alignItems: 'center',
            fontWeight: '600',
            fontStyle: 'normal',
            lineHeight: '16px',
            letterSpacing: '0.05em',
            position: 'relative',
            width: '188px',
            justifyContent: 'center',
            height: '40px',
            background: theme.palette.common?.white || '#ffffff',
            boxSizing: 'border-box',
            cursor: 'pointer',
            [theme.breakpoints.down(599)]: {
                width: '60px',
                minWidth: 'max-content',
                padding: '0px 2px',
            },
        },
        '& svg': {
            marginLeft: '0',
            marginTop: '0',
            height: '0',
            width: '0',
        },
        [theme.breakpoints.down(599)]: {
            marginRight: '0.5rem',
        },
    },
    filterButton: {
        flex: '1',
        display: 'flex',
        alignItems: 'center',
        '&>span': {
            fontSize: '1rem',
            display: 'flex',
            alignItems: 'center',
            fontWeight: '600',
            fontStyle: 'normal',
            lineHeight: '16px',
            letterSpacing: '0.05em',
            position: 'relative',
            width: '190px',
            justifyContent: 'center',
            height: '40px',
            background: theme.palette.common?.white || '#ffffff',
            border: `1px solid ${theme.palette.upsellsTextColor || '#2F2F2F'}`,
            boxSizing: 'border-box',
            cursor: 'pointer',
            [theme.breakpoints.down(599)]: {
                width: '100%',
            },
        },
        '& svg': {
            marginLeft: '10px',
            marginTop: '2px',
            height: '18px',
            width: '18px',
        },
        [theme.breakpoints.down(599)]: {
            marginRight: '0.5rem',
        },
    },
    mainDialog: {
        '& .MuiDialog-paperWidthSm': {
            width: '100%',
            minHeight: 'calc(100% - 64px)',
        },
        '& .MuiDialogContent-dividers': {
            borderTop: 0,
            borderBottom: 'none',
            padding: '0 15px 10px 15px',
            [theme.breakpoints.down(415)]: {
                padding: '0 12px 10px 12px',
            },
        },
        '& .MuiDialogTitle-root': {
            textAlign: 'center',
        },
        [theme.breakpoints.down(481)]: {
            '& > div > div': {
                marginLeft: '15px',
                marginRight: '15px',
            },
        },
    },
    closebutton: {
        '& span': {
            width: '170px',
            border: '1px solid',
            margin: '0 auto',
            display: 'block',
            textAlign: 'center',
            padding: '12px 0px',
            fontWeight: '600',
            fontSize: '15px',
            marginBottom: '25px',
            fontFamily: 'Garamond, Times, serif',
            [theme.breakpoints.down(481)]: {
                width: '150px',
                padding: '8px 0px',
                fontSize: '16px',
            },
        },
        [theme.breakpoints.down(481)]: {
            marginTop: '10px',
        },
    },
    closeX: {
        backgroundColor: 'transparent',
        border: 'none',
        minHeight: 'max-content',
        '& svg': {
            color: theme?.palette?.black || '#2F2F2F',
            width: '24px',
        },
    },
    dialogHeading: {
        display: 'flex',
        justifyContent: 'space-between',
        boxShadow: '0 0 4px 2px rgba(12, 12, 12, 0.15)',
        zIndex: '12',
        padding: '8px 0px 8px 23px',
        alignItems: 'center',
        '& .MuiDialogTitle-root': {
            alignSelf: 'center',
            padding: 0,
            [theme.breakpoints.down(481)]: {
                padding: '0',
                '& h2': {
                    fontSize: '1.25rem',
                    fontFamily: 'latobold, Arial, Verdana, sans-serif',
                    '& svg': {
                        position: 'relative',
                        top: '3px',
                    },
                },
            },
        },
        '& *': {
            textAlign: 'left',
        },
        [theme.breakpoints.down(481)]: {
            padding: '10px 8px 10px 16px',
        },
    },
    dialogFooter: {
        display: 'flex',
        padding: '12px 0',
        justifyContent: 'center',
        gap: '15px',
        minHeight: 'max-content',
        [theme.breakpoints.up(415)]: {
            gap: '22px',
        },
        [theme.breakpoints.down(380)]: {
            gap: '10px',
        },
        boxShadow: '0 0 4px #00000040',
        zIndex: '20',
    },
    footerBtn: {
        fontSize: '1rem',
        fontFamily: 'latobold, Arial, Verdana, sans-serif',
        textTransform: 'uppercase',
        lineHeight: '1em',
        padding: '8px 22px 9px',
        minHeight: 'max-content',
        [theme.breakpoints.down(320)]: {
            padding: '8px 10px 9px',
        },
    },
    footerBtnLight: {
        color: '#2F2F2F',
        backgroundColor: '#FFFFFF',
        border: '1px solid #2F2F2F',
    },
    footerBtnDark: {
        backgroundColor: '#2F2F2F',
        color: '#FFFFFF',
        border: 'none',
    },
    mobileFilterContainer: {
        [theme.breakpoints.down(599)]: {
            display: 'block',
        },
    },
    filterFacetContainer: {
        alignItems: 'center !important',
    },
    totalResultsTablet: {
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '16px',
        lineHeight: '18px',
        marginLeft: '10px',
        minWidth: '80px',
    },
    totalResults: {
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '18px',
        minWidth: '80px',
        alignItems: 'center',
        display: 'flex',
    },
    flexBox: {
        display: 'flex',
        marginBottom: '10px',
        marginTop: '10px',
    },
    makeCenter: {
        paddingBottom: '13px',
    },
    singleLayout: {
        height: '20px',
        width: '20px',
        minWidth: '20px',
        borderRadius: 0,
        padding: 0,
        content: 'url("https://www.plants.com/_next/static/images/grid-layout-10a1289016ac61bcdb4d991df5972142.png")',
    },
    gridLayout: {
        height: '20px',
        width: '20px',
        minWidth: '20px',
        borderRadius: 0,
        padding: 0,
        content: 'url("https://www.plants.com/_next/static/images/full-layout-6a6b4ee1b0bd94bfa1f7556eba71b386.png")',
    },
    layoutToggleWrapper: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        lineHeight: '40px',
    },
});

const MobileProductFacetsV3 = ({
    isFoodBrand,
    classes,
    productFacetsBase,
    isFacetFiltersCountEnabled,
    category,
    trackEventAction,
    openDisplayFacets,
    setFacetsDataInCollection,
    svgIconData,
    displayDeliveryMethod,
    isFilterFactsV2,
    presentation_family,
    setFilterDataInCategoryBuilder,
    setCheckedOptions,
    checkedOptions,
    resetChecked,
    openFacetDropdown,
    productCount,
    productDisplayLayout,
    forPlantGuide,
    selectedFacet,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isGridLayout, setGridLayout] = useState(false);

    const isMobile = useMediaQuery('(max-width: 600px)');
    const isTablet = useMediaQuery('(max-width: 768px)');
    const toggleFilterDialog = () => {
        setIsModalOpen(!isModalOpen);
    };

    const toggleGridLayout = () => {
        setGridLayout(!isGridLayout);
        productDisplayLayout(!isGridLayout);
    };

    const numberOfFilterParams = (checkedOptions?.length && !isFoodBrand) ? checkedOptions.length : 0;

    return (
        <>
            <div className={presentation_family === 'flower' ? `${classes.mainFilterContainerMobileV3} ${classes.filterFacetContainer}` : `${classes.mainFilterContainerMobileV3} ${forPlantGuide ? 'plantGuide' : ''}`}>
                {/* "Sort By" button */}
                {!forPlantGuide && (
                    <div className={classes.mobileFilterContainer}>
                        {/* Sort By options shown in a drawer */}
                        <DesktopFilterDialogV3
                            displayDeliveryMethod={displayDeliveryMethod}
                            setFilterOptions={setFilterDataInCategoryBuilder}
                            brand={category?.brand}
                            presentationFamily={presentation_family}
                            isFilterFactsV2={isFilterFactsV2}
                        />
                    </div>
                )}
                {/* Filter Button */}
                <div className={presentation_family === 'flower' ? classes.filterButton : classes.filterButtonFood}>
                    <span className={numberOfFilterParams ? classes.selectedFilterButton : ''} role="presentation" onClick={() => toggleFilterDialog()}>
                        {svgIconData(classes, isModalOpen, numberOfFilterParams)}
                    </span>
                    {isTablet && !isMobile && <CollectionProductCountUI itemCount={productCount} styleClass={classes.totalResultsTablet} />}
                    {isMobile && <CollectionProductCountUI itemCount={productCount} styleClass={classes.totalResultsTablet} />}
                </div>
                {!forPlantGuide && (
                    <div className={classes.layoutToggleWrapper}>
                        <Button className={isGridLayout ? classes?.singleLayout : classes?.gridLayout} onClick={() => toggleGridLayout()} />
                    </div>
                )}
            </div>

            <div className={classes.flexBox}>
                {/* Pill shaped labels that show applied filters */}
                <FilterChipsUI
                    isInModal={false}
                    productFacetsBase={productFacetsBase}
                    checkedOptions={selectedFacet || checkedOptions}
                    setCheckedOptions={setCheckedOptions}
                    setFacetsDataInCollection={setFacetsDataInCollection}
                    resetChecked={resetChecked}
                />
            </div>

            {isModalOpen
            && (
                <Dialog
                    open={isModalOpen}
                    maxWidth="sm"
                    className={classes.mainDialog}
                    PaperProps={{ square: true }}
                    in={isModalOpen}
                >
                    <div className={classes.dialogHeading}>
                        <DialogTitle className={classes.center}id="customized-dialog-title">
                            Filter <FilterIcon />
                        </DialogTitle>
                        <button type="button" aria-label="close" className={classes.closeX} onClick={toggleFilterDialog}><CloseIcon /></button>
                    </div>

                    <FilterChipsUI
                        isInModal
                        productFacetsBase={productFacetsBase}
                        checkedOptions={selectedFacet || checkedOptions}
                        setCheckedOptions={setCheckedOptions}
                        setFacetsDataInCollection={setFacetsDataInCollection}
                        openFacetDropdown={openFacetDropdown}
                        resetChecked={resetChecked}
                    />

                    <MuiDialogContent dividers>
                        <Typography gutterBottom>
                            <div className={classes.contentpassport}>
                                {productFacetsBase?.length > 0 && (
                                    <ProductFacetsV3
                                        category={category}
                                        productFacets={productFacetsBase}
                                        setFacetsDataInCollection={setFacetsDataInCollection}
                                        isFoodBrand={isFoodBrand}
                                        isFacetFiltersCountEnabled={isFacetFiltersCountEnabled}
                                        track={trackEventAction}
                                        isPopFilterSlider
                                        filterOn="Search"
                                        openDisplayFacets={openDisplayFacets}
                                        setCheckedOptions={setCheckedOptions}
                                        checkedOptions={selectedFacet || checkedOptions}
                                        openFacetDropdown={openFacetDropdown}
                                    />
                                )}
                            </div>
                        </Typography>
                    </MuiDialogContent>
                    <div className={classes.dialogFooter}>
                        <button type="button" aria-label="close" className={`${classes.footerBtn} ${classes.footerBtnLight}`} onClick={toggleFilterDialog}>
                            <span>Close</span>
                        </button>
                        <button type="button" aria-label="close" className={`${classes.footerBtn} ${classes.footerBtnLight}`} onClick={resetChecked}>
                            <span>Clear</span>
                        </button>
                        <button type="button" aria-label="close" className={`${classes.footerBtn} ${classes.footerBtnDark}`} onClick={toggleFilterDialog}>
                            <span>Apply</span>
                        </button>
                    </div>
                </Dialog>
            )}
        </>
    );
};

MobileProductFacetsV3.propTypes = {
    classes: object.isRequired,
    isFoodBrand: bool.isRequired,
    productFacetsBase: arrayOf(shape({
        name: string,
        entries: arrayOf(shape({
            count: number,
            from: number,
            name: string,
            value: string,
        })),
    })),
    isFacetFiltersCountEnabled: bool.isRequired,
    category: shape({
        id: string,
        name: string,
        productFacets: arrayOf(shape({
            name: string,
            entries: arrayOf(shape({
                count: number,
                from: number,
                name: string,
                value: string,
            })),
        })),
    }),
    trackEventAction: func,
    svgIconData: func.isRequired,
    setFacetsDataInCollection: func.isRequired,
    displayDeliveryMethod: bool.isRequired,
    presentation_family: string.isRequired,
    setFilterDataInCategoryBuilder: func.isRequired,
    isFilterFactsV2: bool.isRequired,
    openDisplayFacets: bool,
    setCheckedOptions: func.isRequired,
    checkedOptions: array.isRequired,
    resetChecked: func.isRequired,
    openFacetDropdown: string.isRequired,
    productCount: number,
    productDisplayLayout: bool.isRequired,
    forPlantGuide: bool,
    selectedFacet: array,
};

MobileProductFacetsV3.defaultProps = {
    productFacetsBase: [],
    category: {},
    trackEventAction: () => {},
    openDisplayFacets: false,
    productCount: 0,
    forPlantGuide: false,
    selectedFacet: [],
};

const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});
const enhance = compose(
    withRouter,
    withStyles(styles),
    connect(mapStateToProps, null),
);

export default enhance(MobileProductFacetsV3);
